import type { NDateLocale } from './enUS'
import { cs } from 'date-fns/locale'

const dateCsCZ: NDateLocale = {
  name: 'cs-CZ',
  locale: cs
}

export default dateCsCZ
